module.exports = __webpack_public_path__ + "static/media/LogoHeaderVitalbookBig.bf838974.svg";